<template>
    <li :class="{'notthismonth': !isSelectedMonth, 'today': isToday}">
        <div class="date">{{ dayString }}</div>
        <ul class="rsv_item_wrap">
            <ReservationCalendarIcon v-for="(reservation, index) in reservations" :key="index"
                :reservation="reservation"
                :selectedReservation="selectedReservation"
                @action_SelectReservation="handleReservationSelect"
                @action_ReservationMouseOver="handleReservationMouseOver"/>
        </ul>
    </li>
</template>

<script>
const moment = require('@/util/MPMoment')
import ReservationCalendarIcon from './ReservationCalendarIcon.vue'

export default {
    components: { ReservationCalendarIcon },
    props: {
        reservationDic: Object,
        selectedMonth: Object,
        date: Object,
        selectedReservation: Object
    },
    data() {
        return {
            
        }
    },
    watch: {

    },
    computed: {
        isSelectedMonth: function() {
            if (this.date == undefined || this.selectedMonth == undefined) { return }
            let monthString = this.selectedMonth.format('YYYY-MM')
            return monthString == this.date.format('YYYY-MM')
        },
        isToday: function() {
            let today = moment().format('YYYY-MM-DD')
            let day = this.date.format('YYYY-MM-DD')
            if (today == day) { return true }
            return false
        },
        dayString: function() {
            if (this.date == undefined) { return }
            if (this.date.format('D') == '1') { return this.date.format('M/D')}
            return this.date.format('D')
        },
        reservations: function() {
            if (this.reservationDic == undefined) { return }
            let key = this.date.format('YYYY-MM-DD')
            return this.reservationDic[key]
        },
    },
    methods: {
        handleReservationSelect(reservation) {
            this.$emit('action_SelectReservation', reservation)
        },

        handleReservationMouseOver(reservation, hoverEvent, isShow) {
            this.$emit('action_ReservationMouseOver',reservation, hoverEvent, isShow)
        }
    }
}
</script>
